import { Box, Grid } from "@mui/material";
import React, { useEffect, useState, useSyncExternalStore } from "react";
import OrderCard from "./OrderCard";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useDispatch, useSelector } from "react-redux";
import { getOrderHistory } from "../../../Redux/Customers/Order/Action";
import BackdropComponent from "../BackDrop/Backdrop";

const orderStatus = [
  { label: "Placed", value: "PLACED" },
  { label: "Confirmed", value: "CONFIRMED" },
  { label: "Shipped", value: "SHIPPED" },
  { label: "Delivered", value: "DELIVERED" },
];

const Order = () => {
  const [selectedStatus, setSelectedStatus] = useState([]);
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { order } = useSelector((store) => store);

  useEffect(() => {
    dispatch(getOrderHistory({ jwt }));
  }, [jwt]);

  const handleOrderStatus = (e) => {
    const { value } = e.target;
    if (selectedStatus.includes(value)) {
      setSelectedStatus(selectedStatus.filter((status) => status != value));
    } else {
      setSelectedStatus([...selectedStatus, value]);
    }
  };

  useEffect(() => {
    dispatch(getOrderHistory({ jwt, status: selectedStatus }));
  }, [selectedStatus]);

  return (
    <Box className="px-5 mt-7 mb-7">
      <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
        <Grid item xs={12} sm={3} className="">
          <div className="h-auto shadow-sm bg-[#FFFBF2] border p-5 sticky top-5 bottom-5 mb-7">
            <div className="space-y-4">
              <h3 className="font-semibold text-[#B28585]">ORDER STATUS</h3>
              {orderStatus.map((option, optionIdx) => (
                <div key={option.value} className="flex items-cente">
                  <input
                    //   id={`filter-${section.id}-${optionIdx}`}
                    //   name={`${section.id}[]`}
                    defaultValue={option.value}
                    type="checkbox"
                    defaultChecked={option.checked}
                    value={option.value}
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                    onChange={(e) => handleOrderStatus(e)}
                  />
                  <label
                    //   htmlFor={`filter-${section.id}-${optionIdx}`}
                    className="ml-3 text-sm text-gray-600"
                  >
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={9}>
          <Box className="space-y-5 ">
            {order.orders?.length > 0 &&
              order.orders?.map((order) => {
                return order?.orderItems?.map((item, index) => (
                  <OrderCard item={item} order={order} />
                ));
              })}
          </Box>
        </Grid>
      </Grid>

      <BackdropComponent open={order.loading} />
    </Box>
  );
};

export default Order;
